// import { LogLevel } from "@azure/msal-browser";

export const msalConfig = {
    auth: {
        // stt
        clientId: "d33dc83e-d96c-4e67-92b3-5e80468eea87",
        authority: "https://login.microsoftonline.com/08557a0b-c685-40ea-92b5-b0c5037052eb/",
        redirectUri: "http://localhost:3000/"

        // contenterra
        // clientId: "1fe3270d-0b4b-4d22-a9cf-1757f2c7c817",
        // authority: "https://login.microsoftonline.com/31f960f6-1a5d-4263-ac03-d5ae57903684/",
        // redirectUri: "http://localhost:3001/"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    // system: {	
    //     loggerOptions: {	
    //         loggerCallback: (level: any, message: any, containsPii: any) => {	
    //             if (containsPii) {		
    //                 return;		
    //             }		
    //             switch (level) {		
    //                 case LogLevel.Error:		
    //                     console.error(message);		
    //                     return;		
    //                 case LogLevel.Info:		
    //                     console.info(message);		
    //                     return;		
    //                 case LogLevel.Verbose:		
    //                     console.debug(message);		
    //                     return;		
    //                 case LogLevel.Warning:		
    //                     console.warn(message);		
    //                     return;		
    //             }	
    //         }	
    //     }	
    // }
};

export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
